import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import {
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COMPANY_EMAIL,
  COMPANY_NAME,
  FOOTER_DISCLAIMER,
  SITE_NAME,
  SITE_TAGLINE,
} from '../../constants/site';
import { PHONE_DISPLAY, PHONE_TEL } from '../../constants/contact';
import './ExploreFooter.css';

const FOOTER_NAV = [
  { hash: '#home', label: 'Search' },
  { hash: '#hotels', label: 'Hotels' },
  { hash: '#cars', label: 'Cars' },
  { hash: '#packages', label: 'Packages' },
  { hash: '#cruises', label: 'Cruises' },
  { hash: '#enquiry', label: 'Contact' },
];

export default function ExploreFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="explore-footer">
      <div className="container explore-footer__main">
        <div className="explore-footer__brand">
          <p className="explore-footer__logo">{SITE_NAME}</p>
          <p className="explore-footer__tagline">{SITE_TAGLINE}</p>
          <p className="explore-footer__intro">
            Search hotels, cars, packages, and cruises with 24/7 concierge support.
          </p>
        </div>

        <nav className="explore-footer__nav" aria-label="Footer navigation">
          <h4>Explore</h4>
          <ul>
            {FOOTER_NAV.map(({ hash, label }) => (
              <li key={hash}>
                <a href={hash}>{label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="explore-footer__contact">
          <h4>Contact</h4>
          <a href={`tel:${PHONE_TEL}`} className="explore-footer__cta">
            <FaPhoneAlt aria-hidden />
            <span>
              <small>Call 24/7</small>
              <strong>{PHONE_DISPLAY}</strong>
            </span>
          </a>
          <a href={`mailto:${COMPANY_EMAIL}`}>
            <FaEnvelope aria-hidden /> {COMPANY_EMAIL}
          </a>
          <p className="explore-footer__address">
            <FaMapMarkerAlt aria-hidden />
            <span>
              {ADDRESS_LINE1}
              <br />
              {ADDRESS_LINE2}
            </span>
          </p>
        </div>
      </div>

      <div className="container explore-footer__legal">
        <details className="explore-footer__disclosure">
          <summary>Legal &amp; disclosures</summary>
          <div className="explore-footer__disclosure-body">
            {FOOTER_DISCLAIMER.map((paragraph) => (
              <p key={paragraph.slice(0, 48)}>{paragraph}</p>
            ))}
            <p className="explore-footer__company-line">
              <strong>{COMPANY_NAME}</strong> · {ADDRESS_LINE1}, {ADDRESS_LINE2}
            </p>
          </div>
        </details>
      </div>

      <div className="explore-footer__bar">
        <div className="container explore-footer__bar-inner">
          <p className="explore-footer__copy">
            &copy; {year} {COMPANY_NAME}. All rights reserved.
          </p>
          <a href={`tel:${PHONE_TEL}`} className="explore-footer__bar-phone">
            <FaPhoneAlt aria-hidden /> {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </footer>
  );
}
